export enum RelationTypeEnum {
  PARTNER = 'PARTNER',
  BUSINESS_PARTNER = 'BUSINESS_PARTNER',
  PARENT_CHILD = 'PARENT_CHILD',
  OTHER = 'OTHER',
}
